import React from 'react';
import { Redirect } from 'react-router-dom';
import ProfileSidebar from './ProfileSidebar';
import { getUserSession } from '../../services/authService';
import '../../styles/profile.css';

const LegalItems = ({ items }) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <ul className="profile-legal-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

const LegalBlock = ({ section }) => (
  <>
    {section.body ? <p className="profile-legal-body">{section.body}</p> : null}
    <LegalItems items={section.items} />
    {section.subsections
      ? section.subsections.map((subsection) => (
          <div key={subsection.title} className="profile-legal-subsection">
            <h3 className="profile-legal-subtitle">{subsection.title}</h3>
            {subsection.body ? <p className="profile-legal-body">{subsection.body}</p> : null}
            <LegalItems items={subsection.items} />
          </div>
        ))
      : null}
  </>
);

const ProfileLegalContent = ({ activeId, title, sections, footer }) => {
  const sessionUser = getUserSession();

  if (!sessionUser) {
    return <Redirect to="/iniciar-sesion" />;
  }

  return (
    <div className="profile-root">
      <div className="profile-layout">
        <ProfileSidebar activeId={activeId} />

        <section className="profile-main">
          <h1 className="profile-legal-title">{title}</h1>

          <div className="profile-legal-copy">
            {sections.map((section, index) => (
              <article key={section.title} className="profile-legal-section">
                <h2 className="profile-legal-section-title">
                  <span>{index + 1}. </span>
                  {section.title}
                </h2>
                <LegalBlock section={section} />
              </article>
            ))}

            {footer ? <p className="profile-legal-footer">{footer}</p> : null}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProfileLegalContent;
